import { render, staticRenderFns } from "./VersionLow.vue?vue&type=template&id=fef9307a&scoped=true"
import script from "./VersionLow.vue?vue&type=script&lang=js"
export * from "./VersionLow.vue?vue&type=script&lang=js"
import style0 from "./VersionLow.vue?vue&type=style&index=0&id=fef9307a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef9307a",
  null
  
)

export default component.exports